import { render, staticRenderFns } from "./discardChangesModal.vue?vue&type=template&id=61e9c74f&scoped=true"
import script from "./discardChangesModal.vue?vue&type=script&lang=js"
export * from "./discardChangesModal.vue?vue&type=script&lang=js"
import style0 from "./discardChangesModal.vue?vue&type=style&index=0&id=61e9c74f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e9c74f",
  null
  
)

export default component.exports